module.exports = __webpack_public_path__ + "static/media/dayCount.5427ad0d.png";